import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import DatePicker from 'react-datepicker';
import Textarea from 'react-textarea-autosize';
import moment from 'moment';
import 'moment-timezone';

// Components
import * as icons from '../Icons/Icons';
import TimeSelect2 from './TimeSelect2';

const ScheduleFields = observer(class ScheduleFields extends React.Component {
  constructor() {
    super();
    this.handleLocationDateChange = this.handleLocationDateChange.bind(this);
    this.addLocation = this.addLocation.bind(this);
    this.removeLocation = this.removeLocation.bind(this);
  }

  componentWillMount() {
    const { instructorAsProctor, index } = this.props;

    if(instructorAsProctor.length > 0 && instructorAsProctor[index].startTime) {
      this.state = {
        locationDate: moment(instructorAsProctor[index].startTime)
      }
    } else {
      this.state = {
        locationDate: null
      }
    }
  }

  handleLocationDateChange(date) {
    this.setState({
      locationDate: date
    }, function(){
      this.updateLocation();
    });
  }

  addLocation(e) {
    e.preventDefault();
    this.props.store.ExamStore.addLocation();
  }

  removeLocation(e, i) {
    e.preventDefault();
    this.props.store.ExamStore.removeLocation(i);

    // const { instructorAsProctor, index } = this.props;
    //
    // this.setState({
    //   locationDate: moment(instructorAsProctor[index].startTime)
    // });
  }

  updateLocation() {
    const { userTimezone } = this.props.store.SessionStore;

    let location = {}

    let startTime = null;
    let endTime = null;

    if(this.state.locationDate) {
      const timezone = moment(this.state.locationDate).tz(userTimezone).format('Z');
      let startDate = moment(this.state.locationDate).format('YYYY-MM-DD');
      startTime = moment(`${startDate} ${this.start.value} ${timezone}`, 'YYYY-MM-DD HH:mm Z').toISOString();

      if(this.range.value === 'between') {
        let endDate = moment(this.state.locationDate).format('YYYY-MM-DD');
        endTime = moment(`${endDate} ${this.end.value} ${timezone}`, 'YYYY-MM-DD HH:mm Z').toISOString();
      }
    }

    location = {
      location: this.location.value || null,
      timeType: this.range.value || 'between',
      startTime,
      endTime,
      capacity: 0
      // capacity: this.capacity.value || 0,
    }

    if(location.timeType === 'at') {
      delete location.endTime;
    }

    this.props.store.ExamStore.updateLocation(this.props.index, location);
  }

  render() {
    const { exam, index, translation, instructorAsProctor } = this.props;
    const { userTimezone } = this.props.store.SessionStore;

    if(instructorAsProctor) {
      return (
        <div>
          <ul className="fields schedule-list">
            <li className="field--full">
              <div className="field-wrap">
                <label className="lbl-required" htmlFor="exam-location">{translation.location_helper}</label>
                <Textarea
                  id="exam-location"
                  placeholder={translation.location_helper}
                  ref={(input) => {this.location = input}}
                  onChange={(e) => this.updateLocation(e)}
                  value={instructorAsProctor[index].location || ''}
                  required
                  aria-required="true"
                  disabled={this.props.readonly ? true : false}
                ></Textarea>
              </div>

              {/* <div className="field-wrap">
                <label className="lbl-required" htmlFor="exam-capacity">Capacity</label>
                <input
                  type="number"
                  id="exam-capacity"
                  min="0"
                  placeholder="0"
                  ref={(input) => {this.capacity = input}}
                  onChange={(e) => this.updateLocation(e)}
                  required
                  aria-required="true"
                  value={instructorAsProctor[index].capacity}
                />
              </div> */}
            </li>
            <li className="schedule-list__date">
              <label className="lbl-required">{translation.date}</label>
              {instructorAsProctor[index].startTime &&
                <DatePicker
                  selected={instructorAsProctor[index].startTime ? moment(instructorAsProctor[index].startTime).tz(userTimezone) : null}
                  openToDate={moment(exam.configuration.examOpenDate)}
                  minDate={exam.configuration.examOpenDate}
                  maxDate={exam.configuration.examCloseDate}
                  placeholderText={translation.date_helper}
                  onChange={this.handleLocationDateChange}
                  required
                  aria-required="true"
                  disabled={this.props.readonly ? true : false}
                  autoComplete="off"
                />
              }

              {!instructorAsProctor[index].startTime &&
                <DatePicker
                  selected={this.state.locationDate ? moment(this.state.locationDate).tz(userTimezone) : null}
                  openToDate={moment(exam.configuration.examOpenDate)}
                  minDate={exam.configuration.examOpenDate}
                  maxDate={exam.configuration.examCloseDate}
                  placeholderText={translation.date_helper}
                  onChange={this.handleLocationDateChange}
                  required
                  aria-required="true"
                  disabled={this.props.readonly ? true : false}
                  autoComplete="off"
                />
              }
            </li>
            <li>
              <label className="select">
                <select
                  ref={(input) => {this.range = input}}
                  onChange={(e) => this.updateLocation(e)}
                  value={instructorAsProctor[index].timeType}
                  disabled={this.props.readonly ? true : false}
                >
                  <option value="between">{translation.between}</option>
                  <option value="at">{translation.at}</option>
                </select>
              </label>
            </li>
            <li>
              <label className="select">
                <select
                  ref={(input) => {this.start = input}}
                  onChange={(e) => this.updateLocation(e)}
                  value={
                    instructorAsProctor[index].startTime ?
                    moment(instructorAsProctor[index].startTime).tz(userTimezone).format('HH:mm') :
                    '08:00'
                  }
                  required
                  aria-required="true"
                  disabled={this.props.readonly ? true : false}
                >
                  <option value="">{translation.start}</option>
                  <TimeSelect2 />
                </select>
              </label>

              {instructorAsProctor[index].timeType !== 'between' &&
                <span className="preposition">
                  {/* If a date is selected, use that date’s dst */}
                  {this.state.locationDate &&
                    moment.utc(this.state.locationDate).tz(userTimezone).format('z')
                  }

                  {/* Otherwise use the current date’s dst */}
                  {!this.state.locationDate &&
                    moment().tz(userTimezone).format('z')
                  }
                </span>
              }
            </li>
            <li className={instructorAsProctor[index].timeType === 'between' ? '' : 'disabled'}>
              <span className="preposition">{translation.and}</span>
              <label className="select">
                <select
                  ref={(input) => {this.end = input}}
                  onChange={(e) => this.updateLocation(e)}
                  value={
                    instructorAsProctor[index].endTime ?
                    moment(instructorAsProctor[index].endTime).tz(userTimezone).format('HH:mm') || '17:00' :
                    '17:00'
                  }
                  required={instructorAsProctor[index].timeType === 'between'}
                  aria-required={instructorAsProctor[index].timeType === 'between'}
                  disabled={this.props.readonly ? true : false}
                >
                  <option value="">{translation.end}</option>
                  <TimeSelect2 />
                </select>
              </label>

              <span className="preposition">
                {/* If a date is selected, use that date’s dst */}
                {this.state.locationDate &&
                  moment.utc(this.state.locationDate).tz(userTimezone).format('z')
                }

                {/* Otherwise use the current date’s dst */}
                {!this.state.locationDate &&
                  moment().tz(userTimezone).format('z')
                }
              </span>
            </li>
          </ul>

          <div className="schedule-buttons">
            <button
              className="btn--add"
              onClick={(e) => this.addLocation(e)}
              disabled={this.props.readonly ? true : false}
            >
              <icons.iconPlus /> <span>{translation.add_row}</span>
            </button>

            <button
              className="btn--remove"
              onClick={(e) => this.removeLocation(e, index)}
              disabled={this.props.readonly ? true : false}
            >
              <icons.iconMinus /> <span>{translation.remove_row}</span>
            </button>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('ScheduleFields')(ScheduleFields);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ScheduleFields.js